export default "__VITE_ASSET__8nd3Z0Ca__"